import { INotification } from "infrastructure/notification";

export interface IReleaseState {
  releaseName: string;
  isLoading: boolean;
  shouldHide: boolean;
  textValidationError: string;
  notifications: INotification[];
}

export const getInitialReleaseState = (): IReleaseState => {
  return {
    releaseName: "",
    shouldHide: false,
    isLoading: false,
    notifications: [],
    textValidationError: ""
  };
};
